export enum LogoStarSize {
  Base = 60,
  Inline = 24,
}
